module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("The Julius-Claudian House")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("\n\tJulius Caesar left no direct heir, since his only daughter, Julia, wife of Pompey, died childless. But his line continued through his niece, Atia, and his great-nephew and adopted son, who ruled the Roman Empire after Julius Caesar’s death and came to be called “the Divine Augustus.”")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "alt": "",
      "src": "images/img001.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c08039","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_xxxxxxxxxxxxx_Dedication.vue
// module id = 66
// module chunks = 0